import React from 'react';
import BaseLayoutTemplate from '../components/environments/BaseLayoutTemplate';
import styled from 'styled-components';
import PageTitle from '../components/atoms/PageTitle';
import { mainColor, breakpoint } from '../components/theme';
import HeadBase from '../components/molecules/HeadBase';
import { CROCCHA_API, MetaDesc, MetaOGP } from '../utils';

const TermsOfUsePage = () => (
  <BaseLayoutTemplate loaded={true}>
    <HeadBase
      metas={{
        title: '利用規約 | tryangle株式会社',
        description: MetaDesc,
        openGraph: {
          type: 'article',
          url: `${CROCCHA_API.SELF_DOMAIN}/terms-of-use/`,
          title: '利用規約 | tryangle株式会社',
          description: MetaDesc,
          images: [
            {
              url: MetaOGP,
              width: 1200,
              height: 630,
              alt: 'tryangle株式会社',
            },
          ],
          site_name: 'tryangle株式会社',
        },
      }}
    />

    <PageTitle title='「croccha」利用規約' span='' />
    <SectionHeader id='header'>
      <LinkList>
        <li>
          <a href='#terms'>
            「croccha」
            <br />
            利用規約
          </a>
        </li>
        <li>
          <a href='#service'>
            「croccha shop」
            <br />
            サービス利用規約
          </a>
        </li>
        <li>
          <a href='#account'>
            「croccha」
            <br />
            公認アカウント 利用規約
          </a>
        </li>
        <li>
          <a href='#guideline'>
            「croccha」
            <br />
            公認アカウントガイドライン
          </a>
        </li>
        <li>
          <a href='#kuroko'>
            「croccha」
            <br />
            レシピ自動生成ツール　クロコちゃん 利用規約
          </a>
        </li>
      </LinkList>
    </SectionHeader>
    <Section>
      <h2 id='terms'>croccha利用規約</h2>

      <p>
        tryangle株式会社 （以下、「当社」といいます。）は、当社が運営するサービス「croccha」（以下、「本サービス」といいます。）の利用と提供に関し、
        以下の通り、croccha利用規約（以下、「本規約」といいます。）を定めます。
      </p>
      <p>
        本規約は、本サービスの利用及び運用に関する当社と会員の関係の全てに適用されます。<br />
        利用を希望するユーザーは、本規約の条項を完全に理解し、かつ同意して頂く必要があります。<br />
        当社は、ユーザーによるcrocchaの利用により、本規約の全ての条項が完全に理解され、かつ同意されたものとみなします。
      </p>

      <p>本サービスをご利用される前に必ず本規約をお読みください。</p>

      <p>ユーザーは、crocchaを利用するためには、当社がcrocchaに関連して取得する個人情報（プライバシーに関する情報を含みます。）の取扱いについて定めた個人情報保護規定に同意し、本規約及び当社が別途定める諸規定を遵守する必要があります。</p>
      <p>当社は、ユーザーの事前の承諾を得ることなく、croccha上での掲載又はユーザーに対して、あらかじめ登録されたメールアドレスにメール送信をする等、当社が妥当であると判断する方法でユーザーに公表又は通知することにより、任意に本規約の全部又は一部を変更できるものとします。また、変更された本規約は当該公表又は通知と同時に適用されるものとします。</p>
      <p>当社は、本サービスの提供にあたり、第三者が提供するサービスを利用する場合があります。詳細は、「行動ターゲティング等について」をご確認ください。なお、利用者は、第1項に基づく本利用規約への同意と同時に、「行動ターゲティング等について」の「2. 第三者が提供するサービスの利用にかかるお客様の同意事項」に同意したものとみなされます。</p>

      {/* <h4>第1条 本規約の範囲及び変更</h4>
      <ol>
        <li>
          本規約は、当社が運営するウェブサイトに共通するサービス（以下、「本サービス」といいます。）の利用に関する規約を定めたものです。{' '}
        </li>
        <li>
          本規約は、本サービスの利用に関して、利用者（第3条で定義します。）全てに適用されるものとします。但し、本サービス以外の当社が提供する各サービスに関して、各サービスに関する利用規約にのみ定めのある規定、又は関連する項目で本規約と各サービスに関する利用規約との間で重複する規定がある場合には、各サービスに関する利用規約の規定のみが適用されます。
        </li>
        <li>
          当社は、利用者の事前の承諾を得ることなく、サイト上での掲載又はメール等の当社が適当と判断する方法で利用者に告知又は通知することにより、適宜、本規約の全部又は一部を変更できるものとします。
        </li>
        <li>
          本規約の全部又は一部が変更された場合、本サービスの利用に関しては、変更後の規約が適用されるものとし、利用者は変更後の規約のみに従うものとします。
        </li>
      </ol>
      <p>
        当社は、ユーザーの事前の承諾を得ることなく、本サービス上での掲載又はユーザーに対して、あらかじめ登録されたメールアドレスにメール送信をする等、当社が妥当であると判断する方法でユーザーに公表又は通知することにより、任意に本規約の全部又は一部を変更できるものとします。また、変更された本規約は当該公表又は通知と同時に適用されるものとします。
      </p> */}

      <h4>第1条 定義</h4>
      <p>
        本規約において使用される用語は、以下各号に定めるとおり定義されるものとします。
      </p>
      <ol>
        <li>
          「ユーザー」とは、crocchaを閲覧するなど、crocchaを利用する全ての者を総称していいます。
        </li>
        <li>
          「会員」とは、当社所定の手続に従い、本規約の全条項を完全に理解及び同意した上で、会員登録を申請し、当社がこれを承認した方をいいます。
        </li>
        <li>
          「ログイン情報」とは、会員がcrocchaにログインするために当社に送信する各種ID、メールアドレス、パスワード等を総称していいます。
        </li>
        <li>
          「投稿コンテンツ」とは、crocchaにおいて会員が投稿したコンテンツをいいます。
        </li>
        <li>
          「販売先ECサイト」とは、crocchaに掲載されている商品の購入先として設定されたcrocchaから遷移するECサイトをいいます。
        </li>
      </ol>

      <h4>第2条 会員登録 </h4>
      <ol>
        <li>
            当社は、以下の何れかの事由が判明した場合は、crocchaの会員登録を申請した方の会員登録を承認しないことができるものとします。
            また、会員登録完了後に、以下の何れかに該当する事由が生じた場合、当社は、何ら事前に通知することなく、当該に対してcrocchaの利用停止、会員登録抹消、その他当社が適当であると考える措置を講ずることができるものとします。
        </li>
        <ul>
          <li>(1) 13歳未満の場合</li>
          <li>
            (2)
            在住する国の法令においてcrocchaを利用することが禁止されている場合（年齢又はその他の理由により法的規制を受ける場合を含みますが、これらに限りません。）
          </li>
          <li>
            (3)
            登録申請の全部又は一部に虚偽又は誤解を生じさせる事実又は情報が含まれている場合
          </li>
          <li>(4) その他登録を承認することがcrocchaの運営・管理のために、不適当であると当社が合理的に判断する場合 </li>
        </ul>
        <li>
          crocchaの会員登録を申請した利用者は、当該申請に対して当社からこれを拒否する旨の意思表示がない限り、次の画面に遷移した時点で会員登録を承認されたものとします。
        </li>
        <li>
          当社が事前に同意する場合を除き、一（いち）利用者が取得できる会員の地位は、1つのみとします。一（いち）利用者が複数の会員の地位を取得すること及び1つの会員の地位を複数のユーザーで共有することは禁止されています。
        </li>
        <li>
          会員は、ログイン情報の不正利用の防止に努め、かつその管理について一切の責任を負うものとします。
        </li>
        <li>
          crocchaへのアクセスに関連して送信されたログイン情報が、会員登録申請時又は会員登録後のログイン情報変更時に当社に登録したログイン情報と同一である場合には、当社は、当該会員からの送信とみなします。また、当社は、ログイン情報を利用して行われた不正使用その他の事故等により会員に生じた損害について何ら責任を負わないものとします。
        </li>
        <li>
          ユーザーは、当社に登録されている会員情報の全部又は一部に変更が生じた場合には、直ちに登録内容を変更するものとします。当該変更を行わなかったことに起因して当該ユーザーに何らかの損害が生じたとしても、当社は一切の責任を負わないものとします。        </li>
        <li>
          当社は、会員が本条に基づきcrocchaの利用停止処分又は登録抹消処分等を受けた場合、当該会員の投稿コンテンツの公開を停止いたします。
        </li>
      </ol>

      <h4>第3条 退会</h4>
      <ol>
        <li>
          会員は、当社所定の手続に従い、いつでも退会することができるものとします。なお、退会手続の完了まで、一定の時間を要することにより、当該会員が何らかの損害を被ったとしても、当社に故意又は重過失がない限り、当社は何らの責任を負わないものとします。
        </li>
        <li>
          当社は、会員が本条に基づき退会した場合、当該会員の投稿コンテンツの公開を停止いたします。
        </li>
        <li>
          会員は、退会手続の完了により、crocchaに関連して提供される全てのサービスを受ける権利、電子メール等による情報の提供を受ける権利、キャンペーンやアンケート等に参加する権利等を含め、crocchaに関する一切の権利及び機会を失う場合があることを承諾するものとします。
        </li>
      </ol>

      <h4>第4条 広告</h4>
      <ol>
        <li>
          当社は、本サービス上において、当社の裁量に基づいて広告を掲載することができるものとし、ユーザーはこれを予め承諾するものとします。
        </li>
        <li>
          当社は、登録ユーザーに対し、本サービスに関するキャンペーン、広告宣伝、運営上の事務連絡その他の内容の電子メールを配信することができるものとします。登録ユーザーは、配信された電子メールから、電子メールの配信を停止することができます。
        </li>
      </ol>

      <h4>第5条 禁止事項</h4>
      <p>
        ユーザーは、crocchaの利用に関連して、以下各号に規定する行為又はこれに該当するおそれがある行為を行ってはならないものとします。
        万一、本条の違反に起因して当社又は第三者に対し何らかの損害、損失又は費用が生じた場合、ユーザーは、当該損害等を全て賠償する責任を負うものとします。
        この場合において、当社は、何ら事前に通知することなく、当該ユーザーに対してcrocchaの利用停止、登録抹消その他当社が合理的であると考える措置を講ずることができるものとします。
      </p>
      <ul>
        <li>
          (1)
          本規約、当社が別途定める諸規定、法令、政省令、規則若しくは条例に反する行為又はこれらの行為を教唆、誘引、勧誘幇助若しくは助長する行為
        </li>
        <li>
          (2)
          虚偽又は誤解を生じさせる情報又は事実（第三者に関する情報又は事実を含みますが、これに限りません。）を登録する行為
        </li>
        <li>
          (3) crocchaの円滑な運営を妨げる行為又はこれに支障をきたす行為
        </li>
        <li>(4) 他人のログイン情報を不正に使用する行為</li>
        <li>
          (5)
          正当な理由なく、第三者又は当社に対して何らかの損害、損失又は費用を生じさせる行為
        </li>
        <li>
          (6)
          第三者又は当社の著作権等の知的財産権、営業秘密、ノウハウ、肖像権、人格権、名誉権、プライバシー権、パブリシティ権その他の権利を侵害する行為又はそれらのおそれのある行為
        </li>
        <li>
          (7)
          自殺、自傷行為、薬物乱用等を教唆、誘引、勧誘、幇助又は助長する投稿コンテンツを投稿する行為
        </li>
        <li>
          (8)
          グロテスク、暴力的な写真、その他一般の方にとって不快に感じると当社が合理的に判断する投稿コンテンツを投稿する行為
        </li>
        <li>
          (9)
          露出度の高い動画、画像（モザイク、ぼかし等を入れたものも含みます。）その他当社が猥褻であると合理的に判断する投稿コンテンツを投稿する行為
        </li>
        <li>
          (10) 第三者を誹謗又は中傷する投稿コンテンツを投稿する行為
        </li>
        <li>
          (11)
          性交、性交類似行為、その他の猥褻な行為を目的とした売春、出会い等を勧誘、誘引又は助長する行為若しくはこれらを目的としたメールアドレスの交換
        </li>
        <li>
          (12)
          出会い系サイト、アダルトサイトその他の違法・有害サイトに誘導する情報（単にリンクを張る行為を含みます。）を掲載する行為
        </li>
        <li>
          (13)
          人種、民族、性別、社会的身分、宗教、信条等について、差別につながる又は差別を助長する投稿コンテンツを投稿する行為
        </li>
        <li>
          (14)
          虚偽の事実及び情報又は第三者の誤認・混同を生じさせる投稿コンテンツを投稿する行為
        </li>
        <li>
          (15)
          極めて有害な行為、他者を傷付ける行為、不敬な行為、不快な行為、マネーロンダリングやギャンブルに関係または誘発する行為
        </li>
        <li>(16)方法を問わず、未成年者を傷付ける行為</li>
        <li>
          (17)
          コンピューターリソースの機能性を妨害、破壊、制限するコンピューターウイルス、コンピューターコード、ファイルまたはプログラムを送信する行為
        </li>
        <li>
          (18)
          国家の統一、完全性、防衛、安全保障または主権を脅かす行為、対外国との友好関係や公の秩序を脅かす行為、法令に違反する行為の実行を誘引する行為、違法行為の捜査を妨げる行為、外国を侮辱する行為
        </li>
        <li>
          (19) 公序良俗に反する行為</li>
        <li>
          (20)
          crocchaを通じて入手した投稿コンテンツ等を私的使用の範囲外で使用する行為
        </li>
        <li>
          (21)
          crocchaを商業目的で利用する行為（但し、当社が予め承諾した場合を除きます。）
        </li>
        <li>
          (22)
          第三者の個人情報を当社及び当該第三者の事前の同意を得ることなく、取得、蓄積、保存、販売、頒布、公開、その他の利用をするためにcrocchaを利用する行為
        </li>
        <li>
          (23)
          その他crocchaの管理・運営のために、当社が不適当であると合理的に判断する行為
        </li>
      </ul>

      <h4>第6条 サービスの変更及び運用の停止・中止</h4>
      <ol>
        <li>
          当社は、任意にcrocchaを構成するサービスの全部又は一部を変更することができるものとします。
        </li>
        <li>
          当社は、ユーザーに対して、crocchaに関連して有料で利用できるサービスを提供することができるものとします。この場合において、ユーザーが当該有料サービスの利用を希望する場合は、当該ユーザーは、当社が別途定める有料サービスに関する利用規約に従うものとします。
        </li>
        <li>
          当社は、以下各号の何れかの事由に該当する場合、crocchaの運用の全部又は一部を停止又は中止することができるものとします。
        </li>
        <ul>
          <li>
            (1)
            当社が、定期的又は緊急にコンピューターシステムの保守又は点検を行う場合
          </li>
          <li>
            (2)
            火災、停電、天災地変、戦争、内乱、暴動、騒擾、労働争議等の予期せぬ事由によりcrocchaの提供が不能又は困難となった場合
          </li>
          <li>
            (3)
            コンピューターシステムの機能不全、第三者からの不正アクセス、コンピューターウイルスの感染等によりcrocchaの提供が不能又は困難となった場合
          </li>
          <li>
            (4)
            行政機関、司法機関その他の公的機関から相当な根拠に基づきcrocchaの停止又は中止を要請された場合
          </li>
          <li>
            (5)
            その他システムの停止又は中止が必要であると当社が合理的に判断した場合
          </li>
        </ul>
        <li>
          当社は、前項に基づきcrocchaを停止又は中止する場合、事前にcroccha上での掲載又はユーザーに対してメール送信をする等、当社が妥当であると判断する方法によりユーザーに公表又は通知するよう努めるものとします。但し、事前の公表又は通知が合理的に不可能又は困難な場合、及び緊急を要する場合は、この限りではありません。
        </li>
        <li>
          当社は、crocchaの停止、中止又はサービスの変更に起因してユーザーに何らかの損害が発生したとしても、当該ユーザーに対し一切の責任を負わないものとします。
        </li>
      </ol>

      <h4>第7条 サービスの終了等</h4>
      <ol>
        <li>
          当社は、任意にcrocchaを構成するサービスの全部又は一部を終了することができるものとします。
        </li>
        <li>
          当社は、前項に基づきサービスの全部又は一部が終了した場合、終了部分に含まれる投稿コンテンツの公開を停止することが出来るものとします。
        </li>
        <li>
          crocchaを構成するサービスの全部が終了した場合、何らかの理由によりユーザーがcrocchaの利用を終了した場合
          （第2条に基づくcrocchaの利用停止、会員登録抹消、第3条に基づく退会を含みますがこれらに限りません。）、本規約は効力を失いますが、
          第1条、第2条第5項乃至第7項、第3条第1項、同条第2項、第5条、第6条第5項、第7条、第8条、第9条、第10条、第12条、第13条、第14条については以後効力を有するものとします。
        </li>
      </ol>

      <h4>第8条 免責事項</h4>
      <ol>
        <li>
          当社は、croccha構成するサービスの安全性を確保し、かつサーバー、ソフトウェア等に生じたバグの修正及び改良に商業上合理的な範囲で努めますが、現在及び将来に亘って、これらの不発生及び不存在を保証しないものとします。
        </li>
        <li>
          当社は、当社の技術上合理的に可能な範囲で、投稿コンテンツに関連して第三者による国内及び国外の著作権法及びその他の法令により禁止されている行為に対抗するため適切な処置を講ずるよう努めるものとします。但し、投稿コンテンツに関連して第三者による何らかの侵害行為が発生したとしても、当社は、当該第三者に対して当該行為の差止めや損害賠償請求等の請求をする義務を負わないことにつき、ユーザーはこれを承諾するものとします。        </li>
        <li>
          第1項、前項及び本規約に別段の定めがある場合に加え、当社は、以下の事由によりユーザーに生じた損害及び損失について一切の責任を負わないものとします。
        </li>
        <ul>
          <li>(1) crocchaの内容又は利用 </li>
          <li>(2) 登録情報及び投稿コンテンツのデータ消失</li>
          <li>
            (3)
            販売先ECサイトの提供する商品並びにサービスの適法性、有効性、正確性、確実性、安全性及び完全性
          </li>
          <li>
            (4)
            crocchaから他のウェブサイト又はリソースへのリンクを提供している場合の当該リンク先の内容、利用及びその結果（適法性、有効性、正確性、確実性、安全性、最新性及び完全性を含みますが、これらに限りません。）
          </li>
          <li>(5) 当社が本規約に従って講じた処置</li>
        </ul>
        <li>
          本規約に定められている当社の免責に関する規定における免責対象には、直接損害・間接損害・偶発損害・派生損害・懲罰的賠償に基づく損害等の一切の損害が含まれます。但し、ユーザーの居住する国における法令に照らして当該損害への免責が否定される場合は、当該法令に照らして最大限認められる範囲において当社の責任が限定されるものとします。
        </li>
      </ol>

      <h4>第9条 監査</h4>
      <p>
        当社は、crocchaの適法且つ健全な運営を目的として、当社又は当社が別途業務を委託する第三者により、ユーザーのcrocchaの利用を監視する権限を有するものとし、ユーザーはこれを承諾するものとします。なお、本条により当社は監視義務を負うものではありません。
      </p>
      <p>
      前項に基づく監視により、投稿コンテンツ等が、本規約又は当社が別途定める諸規定に違反すると当社が合理的に判断した場合には、当社は、ユーザーに何ら事前に通知することなく、当該コンテンツの全部又は一部を非公開とし、又は削除することができるものとします。また、これらの措置によりユーザーに対し何らかの損害又は損失が生じたとしても、当社は一切の責任を負わないものします。
      </p>

      <h4>第10条 知的財産権等</h4>
      <ol>
        <li>
          当社は、crocchaを通じて提供される画像、テキスト、デザイン、ロゴ、映像、プログラム、アイデア、バナー、音楽、並びにcrocchaに表示されるトピックス、ニュース及びメールマガジンに掲載される情報等及びこれに関連する一切の知的財産権を全世界において独占的に保有するものとします。但し、ユーザーが投稿した投稿コンテンツについては、当該ユーザー又は適法な利用権者に帰属するものとします。
        </li>
        <li>
          ユーザー、crocchaにおいて自らが利用及び処分する権限を有し、かつ適法並びに有効に投稿及び登録する権限を有する投稿コンテンツのみを投稿するものとします。
        </li>
        <li>
        ユーザーは、croccha及び当社が運営するサービスの宣伝広告並びに当社及び当社の関連会社の事業での利用等のために、投稿コンテンツ等の知的財産権の全部又は一部を、当社及び当社の関連会社が別途提供するサービスに必要な範囲で全世界において無償且つ非独占的に利用する権利を許諾するものとします。
        </li>
        <li>
          本条の規定に違反して、会員が第三者との間で何らかの問題が生じた場合、会員は自己の責任と費用において当該問題を解決し、当社に対して何らの損害、損失又は費用を生じさせないものとします。また、万が一、当社に何らかの損害、損失又は費用が生じた場合には、会員は、当該損害、損失又は費用を全て賠償又は支出するものとします。
        </li>
      </ol>

      <h4>第11条 権利義務の譲渡禁止</h4>
      <p>
      ユーザーは、当社の書面による事前の承諾なしに、本規約に基づく契約上の地位及び一切の権利又は義務を、第三者に対し譲渡、承継、質入その他一切の処分をしてはならないものとします。
      </p>

      <h4>第12条 分離可分性</h4>
      <p>
        本規約の何れかの条項が無効又は違法となった場合であっても、当該無効又は違法は、如何なる意味でも本規約の他の条項並びにその解釈・適用に何ら影響せず、これらの適法性及び有効性を損なわず、またこれらを無効にするものではありません。
      </p>

      <h4>第13条 準拠法</h4>
      <p>
      本契約の準拠法は日本法とします。理由の如何を問わず、本規約の適用又は履行に関連して日本法の適用が排除される場合には、本規約の趣旨及び条項が最大限に尊重され、かつこれに基づき紛争の解決が図られるものとします。
      </p>

      <h4>第14条 合意管轄</h4>
      <p>
        本規約に関して発生する紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
      </p>

      <h4>第15条 お問合せ</h4>
      <p>
        本規約に関するお問合せ、または権利行使に関するお問合せは、crocchaカスタマーサポートセンターまでご連絡ください。<br />
        info&#64;croccha.jp
      </p>

      <p>
      2019年9月	制定・施行<br />
      2023年5月  改訂<br />
      </p>

      <p>以上</p>

      <h2 id='service'>「croccha shop」サービス利用規約</h2>
      <h3>第1章 総則</h3>
      <h4>第1条 本規約の範囲及び変更</h4>
      <ol>
        <li>
          この規約（以下、「本規約」といいます。）は、当社が運営するウェブサイト「croccha
          shop」に関するサービス（以下、「本サービス」といいます。）の利用に関し、当社及び会員（第3条で定義します。）に適用されるものとします。但し、本サービス以外に当社が提供する各サービスに関しては、当該各サービスに関連する利用規約のみが適用されるものとします。
        </li>
        <li>
          当社は、会員の事前の承諾を得ることなく、ウェブサイト上での掲載又はメール等の当社が適当と判断する方法で会員に告知又は通知することにより、適宜、本規約の全部又は一部を変更できるものとします。
        </li>
        <li>
          本規約の全部又は一部が変更された場合、本サービスの利用に関しては、変更後の規約のみが適用されるものとし、会員は変更後の規約のみに従うものとします。
        </li>
      </ol>

      <h4>第2条 本サービスの利用 </h4>
      <ol>
        <li>
          会員は、法令、条例、規則、通達並びに共通サービス利用規約、本規約及び当社が別途定めるプライバシーポリシー、ヘルプ等に従い、本サービスを利用するものとします。
        </li>
        <li>
          未成年の会員は、適格な法定代理人の事前の同意を得なければ、本サービスを利用することができないものとします。
        </li>
      </ol>

      <h4>第3条 提供するサービス</h4>
      <p>利用者は、本サービスにおいて次の行為を行うことができます。</p>
      <ol>
        <li>
          会員は、当社所定の方法に従い、本サービスを利用して当社から商品等を購入することができる。
        </li>
        <li>crocchaでのサービスの利用</li>
      </ol>

      <h3>第2章 会員</h3>
      <h4>第4条 会員</h4>

      <p>
        本規約において「会員」とは、当社が別途定める＜共通サービス利用規約＞「第3条
        会員登録」の規定が適用されるものとします。
      </p>

      <h4>第5条 会員登録</h4>
      <ol>
        <li>
          会員登録をする際には、＜共通サービス利用規約＞「第3条
          会員登録」に定めた会員登録に必要な項目を入力・設定した上で、登録申請することを前提条件とします。
        </li>
        <li>
          未成年者は、適格な法定代理人の事前の同意がなければ、会員登録申請をすることができないものとします
        </li>
        <li>
          当社は、以下の各号の何れかに該当する場合、当該登録を承認しない場合があります。
          <ul>
            <li>
              (1)
              会員登録の希望者が過去に当社の提供する何らかのサービスに関する規約（本規約及びサイト上に明記した各サービスに関連する他社の規約を含みますが、これらに限りません。）に違反したこと等により、会員登録の抹消等の処分を受けていたことが判明した場合
            </li>
            <li>
              (2)
              会員登録の希望者の申請内容に虚偽の事項が含まれていることが判明した場合
            </li>
            <li>
              (3)
              過去に当社の提供する何らかのサービス（サイト上に明記した各サービスに関連する他社のサービスを含みますが、これらに限りません。）に関して、料金等の支払を履行していない場合（当社が別途認める支払方法に関連する第三者に対して料金等の支払を履行していない場合を含みますが、これに限りません。）、又は、正当な理由なく長期間に亘る商品又はサービス（以下、「商品等」と総称します。）の受取り不能、返品・交換の拒絶その他の債務不履行があったことが判明した場合
            </li>
            <li>
              (4) 過去に＜共通サービス利用規約＞「第5条
              禁止事項」の行為を行ったことが判明した場合
            </li>
            <li>
              (5)
              その他登録を承認することが本サービスの運営・管理上、不適当であると当社が合理的に判断する場合
            </li>
          </ul>
        </li>
      </ol>

      <h4>第6条 登録内容の変更 </h4>
      <ol>
        <li>
          会員は、氏名、住所、電話番号その他当社に登録している事項の全部又は一部に変更が生じた場合には、当社が別途指定する方法により、すみやかに登録内容を変更するものとします。
        </li>
        <li>
          当社は、会員が適宜、変更登録を行わなかったことにより何らかの損害が生じたとしても、一切責任を負わないものとします。
        </li>
      </ol>

      <h4>第7条 本サービスの利用停止及び会員登録の取消</h4>

      <p>
        当社は、会員が以下の各号の何れかに該当する場合、事前通知することなく、当該会員に対して本サービスの利用停止、会員登録抹消その他当社が適当と考える措置を講ずることができるものとします。
      </p>
      <ul>
        <li>
          (1)
          過去に当社の提供する何らかのサービスに関する規約（本規約及びサイト上に明記した各サービスに関連する他社の規約を含みますが、これらに限りません。）に違反をしたこと等により、会員登録の抹消等の処分を受けていたことが判明した場合
        </li>
        <li>(2) 登録された内容に虚偽の事項が含まれていることが判明した場合</li>
        <li>
          (3)
          過去又は現在において、当社の提供する何らかのサービス（サイト上に明記した各サービスに関連する他社のサービスを含みますが、これらに限りません。）に関して、料金等の支払を履行していない場合（当社が別途認める支払方法に関連する第三者に対して料金等の支払を履行していない場合を含みますが、これに限りません。）、又は、正当な理由なく長期間に亘る商品等の受取り不能、返品・交換の拒絶その他の債務不履行があったことが判明した場合
        </li>
        <li>
          (4) ＜共通サービス利用規約＞「第5条
          禁止事項」の行為を行ったことが判明した場合
        </li>
        <li>(5) その他当社の定める何らかの規約に違反した場合</li>
      </ul>

      <h4>第8条 退会手続</h4>
      <p>
        退会を希望する場合は、別途定める＜共通サービス利用規約＞ 「第4条
        退会手続」の規定が適用されるものとします。
      </p>

      <h3>第3章 商品の購入</h3>
      <h4>第9条 商品の購入</h4>
      <ol>
        <li>
          会員は、商品等の購入を希望する場合、当社が別途指定する方法に従って、商品等の購入又は利用を申込むものとします。
        </li>
        <li>
          前項の申込みに伴い、会員が入力・登録した配達先・注文内容等を確認の上で注文する旨のボタンをクリックし、その後、当社から注文内容を確認する旨のメールが会員に到達した時点で、会員と当社との間に当該商品等に関する売買契約が成立するものとします。
        </li>
        <li>
          前項の規定に拘わらず、本サービス利用に関して不正行為又は不適当な行為があった場合、当社は売買契約について取消、解除その他の適切な措置を取ることができるものとします。
        </li>
        <li>本サービスによる商品等の配送は、日本国内に限ります。 </li>
      </ol>

      <h4>第10条 支払方法 </h4>
      <ol>
        <li>
          商品等の支払い金額は、消費税を含む商品等の購入代金及びこれに係わる取り扱い手数料の合計となります。
        </li>
        <li>
          本サービスによって購入された商品等の支払いに関しては、会員本人名義のクレジットカードによる支払、又は当社が別途認める支払方法に限るものとします。
        </li>
        <li>
          クレジットカードで支払われる場合は、会員がクレジットカード会社との間で別途契約する条件に従うものとします。なお、クレジットカードの利用に関連して、会員とクレジットカード会社等の間で何らかの紛争が発生した場合は、会員とクレジットカード会社との間で責任をもって解決するものとします。
        </li>
      </ol>

      <h4>第11条 商品等の返品・交換・注文の撤回及び取消し</h4>
      <ol>
        <li>商品の返品については、以下の場合に限り受け付けるものとします。</li>
        <ul>
          <li>（1) 商品に瑕疵があった場合 </li>
          <li>（2) ご注文内容と異なる商品が到着した場合</li>
          <li>（3) 配送中に破損した商品の場合</li>
          <li>
            （4)
            上記（1）から（3）のいずれにも該当せず、商品到着後7日以内であって、かつ以下のいずれにも該当しない場合。但し、販売ページ上に「返品対象外」の記載がある商品については返品することができません。
          </li>
          <ul>
            <li>①使用済み </li>
            <li>②納品書を紛失した場合 </li>
            <li>③商品ラベルを切り離し、紛失した場合</li>
            <li>
              ④返送時の商品（箱、商品の付属品を含みますが、これらに限りません。）の状態がお届け時と比べて毀損、汚損、紛失等している場合
            </li>
            <li>⑤お客様のもとで商品に汚れ、キズが生じた場合</li>
            <li>
              ⑥パッケージが商品の一部となっている商品において、パッケージを開封した場合
            </li>
            <li>⑦セール商品・アウトレット商品・予約商品である場合</li>
          </ul>
        </ul>
        <li>
          会員は、当社が別途定める手順に従い前項に定める返品を申請するものとし、前項（1）から（3）については返送にかかる費用は当社が負担し、会員が購入した時点の販売価格、配送料ならびに返品対象商品の購入に際して使用したポイントを返還するか、又は代品に交換します。なお、代品への交換を希望された場合においても、商品の欠品等を理由に交換ができないことがあります。また、前項（4）については返送にかかる費用は会員が負担し、当社は会員が購入した時点の販売価格、配送料及びポイントを返還します。
        </li>
        <li>
          会員は、商品の返品を行った場合、当該商品及び会員が返品対象商品の購入に際して取得したポイントを当社に返還するものとし、当社と会員間で相互に返還すべきポイントの処理方法は、対等数をもって相殺する方法により行うものとします。この場合、当社が返還すべきポイント数が、会員が返還すべきポイント数を上回るときは、当該相殺後の残数のポイントを会員に返還するものとし、会員が返還すべきポイント数が、当社が返還すべきポイント数を上回るときは、当該相殺後の残数に相当する額（返品対象商品の購入時点における1ポイントあたりの金額で算定した額）を、当社が会員に返金すべき返品対象商品の購入代金から控除する方法で行うものとします。
        </li>
        <li>
          本条第1項第4号⑦の定めに拘らず、ご注文の撤回及び取消しについては、予約については注文確定から24時間以内、受注商品、セール商品・アウトレット商品については注文確定後から当社における配送準備中までの期間に限り受け付けるものとします。商品の発送処理後から商品到着までの間は、当社の責めに帰すべき事由がある場合を除き、商品のご注文の撤回および取消しをすることができません（商品到着後の返品については、本条第１項の定めるとおりとします）。
        </li>
        <li>
          当社は、会員が正当な理由なく商品を当社に返送した場合（第1項に定める事由に該当しない商品の返品、受領拒否、受領不可等を含みますがこれらに限りません。）、当該商品を受領した後、遅滞なく会員に対し通知し、相当の期間を定めたうえで当該商品の受け取りにつき会員に対して指図をもとめるものとします。
        </li>
        <li>
          当社は、相当の期間内に前項に規定する会員からの指図がない場合、会員に対し予告した上で、その予告をした日から起算して3か月間当該商品を保管するものとします。なお、当社は、当該保管期間内に会員より商品の受け取りに関する指図を受けた場合、当該商品について現状有姿で引渡すものであり、当該商品の状態（商品の変質、変形、消耗、毀損又は腐敗等を含みますがこれらに限りません。）について一切責任を負わないものとします。
        </li>
        <li>
          当社は、前項の保管期間経過後、当該商品の保管期間が終了した旨を会員に対して通知するものとし、当該通知日から起算して7日以内に会員より当該商品の受け取りに関する指図がない場合、廃棄その他当社の定める処分方法により当該商品を処分するものとします。この場合当社は会員に対して一切の責任を負わないものとします。
        </li>
      </ol>

      <h4>第12条 商品等に関する免責</h4>
      <ol>
        <li>
          当社は、本サービス及び本サービスを通じて販売される商品等につき、その品質、材質、機能、性能、他の商品との適合性その他の欠陥、又はこれらが原因となり生じた損害、損失、不利益等については、前条に定める場合を除き、いかなる保証・負担も負わないものとします。
        </li>
        <li>
          当社は、配送先不明等によるトラブルに関しては、会員が登録している連絡先に連絡すること及び商品購入の際に指定された配達先に商品等を配送等することにより、商品等の引渡債務を履行し、当該債務から免責されるものとします。
        </li>
        <li>
          当社は、croccha
          shopのトップページ及び販売ページ上において、crocchaにおける投稿コンテンツ、instagram,twitter等のSNSサービスの利用会員が投稿した商品に関するコメントの内容について、当該コメントの内容が事実に反するものであったとしても、これによる商品を購入した会員に生じた損害に対しては、当社に故意又は重過失がある場合を除き、一切の責任を負わないものとします。
        </li>
      </ol>
      <p>以上</p>

      <h2 id='account'>「croccha」公認アカウント 利用規約</h2>
      <h4>第1条（規約の適用）</h4>
      <ol>
        <li>
          croccha公認アカウント利用規約（以下「本規約」といいます。）は、tryangle株式会社（以下「当社」といいます。）が提供するcroccha公認アカウントに関するすべてのサービス（以下「croccha公認アカウント」といいます。）の利用に関する条件を定めるものであり、croccha公認アカウント利用に係る、当社とお客様との契約の内容となることを確認します。
        </li>
        <li>
          croccha公認アカウントには、本規約に加え、当社が定めるcroccha利用規約（掲載ＵＲＬ)、crocchaアカウントガイドライン（掲載ＵＲＬ)および当社がcroccha公認アカウントの追加サービス（以下「追加サービス」といいます。）毎に定める個別の契約（以下「個別契約」といいます。）が合わせて適用されます。
        </li>
        <li>
          本規約、croccha利用規約、crocchaアカウントガイドラインの定めに矛盾抵触がある場合、個別契約、croccha公認アカウントガイドライン、本規約、croccha利用規約の順序で、該当する定めが優先して適用されます。
        </li>
        <li>
          お客様は、本規約、croccha利用規約、croccha公認アカウントガイドラインに従ってcroccha公認アカウントを利用しなければなりません。また、お客様は、croccha公認アカウントの利用に際して、適用のあるすべての法令を遵守する責任を負います。
        </li>
      </ol>

      <h4>第2条（利用申し込み・認証・認証拒絶または取消）</h4>
      <ol>
        <li>
          お客様は、当社が指定する方法により、個人の場合は「croccha公認クリエイター」アカウント、法人の場合は「croccha公認ショップ」アカウントの利用を申し込むことで、croccha公認アカウントを利用するためのアカウント（以下「本アカウント」といいます。）が提供されます。
          <br />
          その上で、croccha公認アカウントの利用を希望するお客様は、本件利用規約およびcroccha利用規約に同意のうえ、当社が別途定める「croccha
          公認アカウント登録事項/申込書」または電子メールを含む書面（以下、「申込書等」といいます。）に、必要事項を記入して当社に送信し、当社がこれを承諾することによって、croccha公認アカウントを係る「利用契約」（以下「個別契約」といいます。）が成立するものとします。
        </li>
        <li>
          お客様は、当社所定の方法により申し込み、当社の承認を得た場合、本アカウントに当社の認証を受けることができます（以下、当社の認証を受けた本アカウントを「公認アカウント」といいます。）。
        </li>
        <li>
          当社は、当社が定める一定の基準を満たした公認アカウントについて、プレミアムアカウント（以下「プレミアムアカウント」といいます。）とすることがあります。なお、当社は本アカウントをプレミアムアカウントとする基準について、公開する義務を負わないものとします。
        </li>
        <li>
          お客様が以下のいずれかに該当すると当社が判断した場合、当社は、お客様の公認アカウントの申し込みを拒絶することができます。
          <br />
          （1)当社に対し、虚偽の情報を提供したとき
          <br />
          （2)当社所定の審査基準（なお、当社はかかる審査基準を開示する義務を負いません。）を満たさないとき
          <br />
          （3)その他、croccha公認アカウントをご利用いただくことが適当でないと当社が判断したとき
        </li>
        <li>
          当社は、お客様にcroccha公認アカウントの無料または有料の追加サービスを提供することがあります。お客様は、当社が定める当該追加サービスの個別契約に同意すると共に、当社が指定する方法により追加サービスの利用を申し込むことで、追加サービスを利用することができます。
        </li>
      </ol>

      <h4>第3条（本規約の変更）</h4>
      <p>
        当社は、必要に応じ、お客様に公表または通知することにより、本規約およびcroccha公認アカウントが提供するサービスの内容等を変更できるものとします。お客様が、変更後引き続きcroccha公認アカウントを利用した場合、又は当社の定める期間内に登録取消の手続をとらなかった場合、本規約およびサービス内容等の変更に同意したものとみなされます。
      </p>

      <h4>第4条（利用期間）</h4>
      <ol>
        <li>
          croccha公認クリエイターアカウントの利用期間はcroccha公認クリエイター個別契約で定められたものを適用します。公認クリエイターアカウント利用期間終了後は、自動的に一般アカウントとして継続され、本アカウントの削除が完了されるまでとします。
        </li>
        <li>
          croccha公認ショップアカウントには、無料プランと有料プランがあります。
          <br />
          （1)
          無料プランの利用期間は、利用申し込みから本アカウントの削除を完了するまでとします。
          <br />
          （2)
          有料プランの当初の利用期間は、利用申し込みを完了した日の当月末日までとします。お客様が利用期間満了前までに当社所定の方法により有料プランの解約を申し出ない限り、有料プランの利用期間は自動的に1か月間延長されるものとし、その後も同様とします。
        </li>
      </ol>

      <h4>第5条（利用料金）</h4>
      <ol>
        <li>
          有料プランの内容、利用料金、支払期限等は、当社が決定し、お客様に公表または通知しますので、有料プラン申し込み時にご確認ください。
        </li>
        <li>
          当社は、お客様に公表または通知することにより、有料プランを変更または追加することがあります。{' '}
        </li>
        <li>
          お客様が、無料プランから有料プランへの変更を希望する場合、当社の指定する方法で申し込みを行い、当社がそれを受領した日をもって、お客様が希望した有料プランに変更することができるものとします。なお、有料プランから、他の有料プランへの変更または無料プランへの変更を希望する場合、当社の指定する方法で申し込みを行い、当社がそれを受領した日の翌月より、お客様が変更を希望したプランに変更することができるものとします。
        </li>
        <li>
          お客様が、croccha公認アカウント有料プランを購入した場合、購入月の利用料金等は、こちら（掲載URL)からご確認ください。
        </li>
        <li>
          お客様は、月中にcroccha公認アカウントの有料プランを開始又は解約した場合であっても、当該月に適用されている月額利用料全額を支払うものとし、日割り精算は行わないものとします。なお、お客様が前払いした利用料金は、croccha公認アカウントを解約した場合であっても、当社からの返金はないものとします。
        </li>
        <li>
          お客様が、当社に対して利用料金を支払う場合において、消費税法および同法に関する法令の規定により当該支払いについて消費税が賦課されるものとされている場合は、消費税相当額をあわせて支払うものとします。
        </li>
        <li>
          当社は、税抜き利用料金その他の計算において、その計算結果に1円未満の端数が生じた場合はその端数を切り捨てて算出し、当該算出した金額に消費税等を乗じた結果に1円未満の端数が生じた場合はその端数を四捨五入して税込み利用料金その他を算出するものとします。
        </li>
        <li>
          お客様が、croccha公認アカウントの利用代金の支払いを遅延した場合は、当社とお客様との間の本規約に基づく契約関係は自動的に解除されます。かかる解除に起因しお客様に何らかの損害が生じた場合であっても、当社はお客様に対し何ら責任を負わないものとします。加えて、お客様は、その延滞期間につき、未払額に対する年率14.6%（日割り計算）の割合による遅延損害金を当社に支払うものとします。
        </li>
      </ol>

      <h4>第6条（アカウント）</h4>
      <ol>
        <li>
          お客様は、本アカウントのパスワードを不正に利用されないようご自身の責任で厳重に管理するものとします。当社は、登録されたパスワードを利用して行なわれた一切の行為を、お客様の行為とみなします。
        </li>
        <li>
          本アカウントでなされた行為によりお客様に生じた損害や不利益について、当社に、故意または重過失が認められる場合を除き、当社は免責されるものとします。
        </li>
        <li>
          当社は、お客様が希望する場合、合理的な範囲内でお客様による本アカウントの運用を補助することがあります。この場合、当社は、補助に必要な範囲で、お客様の本アカウントにアクセスし、これを操作できるものとします。なお、当該操作に起因してお客様またはcrocchaの利用者（以下「利用者」といいます。）に発生した損害につき、当社は一切その責任を負わないものとします。
        </li>
        <li>
          法人のお客様は、自己の関連会社（お客様の子会社、親会社または関連会社のことをいい、以下「関連会社」といいます。）のために本アカウントを申し込み、利用させることができます。その場合、お客様はかかる関連会社に対し、本規約の定めを遵守させ、関連会社による本規約の履行について責任を負うものとします。当社は、かかる関連会社の行為をお客様の行為とみなします。
        </li>
        <li>
          当社は、croccha公認アカウントの利用にかかる契約が解約または終了した場合もしくはcroccha公認アカウントの提供が終了した場合、本アカウントにかかる情報および本アカウントから配信されたコンテンツ（お客様がcroccha公認アカウントを利用して、利用者に送信しまたは利用者が閲覧可能な状態におくもので、本アカウントのアイコン、プロフィール情報、お客様が発信する文章、画像、動画がふくまれますがこれらに限りません。以下、これらを総称して「本コンテンツ」といいます。）を当社の裁量により削除することができるものとし、お客様はそれに同意するものとします。
        </li>
      </ol>

      <h4>第7条（本コンテンツ）</h4>
      <ol>
        <li>
          お客様は、当社に対して、以下の事項を表明し、保証するものとします。
          <br />
          （1)本コンテンツが、第三者の権利（著作権、著作者人格権、特許権、商標権、意匠権、実用新案権、営業秘密、名誉権、肖像権、プライバシー権、パブリシティー権を含みますが、これらに限りません。）を侵害しないこと
          <br />
          （2)本コンテンツが公序良俗に反するおそれのある内容（過度に暴力的な内容、露骨な性的内容を含みますが、これらに限りません。）、法令または本規約に違反する内容を含まないこと
          <br />
          （3)本コンテンツにURLリンクを含める場合、お客様がアクセス状況を集計可能であることを利用者が認識できるURLに限定するか、または利用者がそのように認識するために必要な措置を行うこと
        </li>
        <li>
          第三者に関する情報を本コンテンツに記載する場合、利用者が当該第三者本人からの情報提供だと誤認しないよう、然るべき記載（例としては、情報の発信元の明示、本人ではないことの明示などがありますが、これらに限りません。）をしなければなりません。
        </li>
        <li>
          お客様は、croccha公認アカウントの適正な運営のため、当社が本コンテンツの内容を確認する場合があることに同意します。当社は、本コンテンツに不適切な内容が含まれていると判断した場合、当該本コンテンツを配信せずまたは削除することができます。
        </li>
        <li>
          当社は、裁判所、捜査機関、その他の公的機関から、本コンテンツを開示・提供するよう請求され、当社がかかる請求が正当であると判断した場合、お客様の承諾を得ることなく、本コンテンツを開示・提供することができるものとします。
        </li>
        <li>
          当社は、本アカウント、本コンテンツおよびcroccha公認アカウントで利用可能な機能の使用実績・使用状況等（お客様がcroccha公認アカウントの利用にあたり登録する情報を含みます。ただし、通信の秘密の保護に抵触しないものに限ります。）を、不正利用の防止、サービスの提供・開発・改善、広告配信、宣伝活動を行うために利用することがあり、お客様は予めこれに同意（当社に対する著作者人格権の不行使を含みます。）するものとします。当社は、当該利用に必要な範囲において、当該使用実績・使用状況等を当社の関連サービスを提供する会社および当社の業務委託先に共有できるものとします。
        </li>
        <li>
          当社は、本コンテンツを当社のサーバに保存できるものとします。なお、当社は本コンテンツの保存義務は一切負わないものとし、お客様は、本コンテンツの保存が必要と考える場合には、自らの費用と責任において本コンテンツの保存を行うものとします。
        </li>
      </ol>

      <h4>第8条 （知的財産権等)</h4>
      <ol>
        <li>
          当社は、当社が運営するサービス「croccha」「croccha
          shop」に関する知的財産権、当社が運営するサービス「croccha」「croccha
          shop」を通じて提供される画像、テキスト、デザイン、ロゴ、映像、プログラム、アイデア、バナー、音楽、並びに当社が運営するサービス「croccha」「croccha
          shop」に表示されるトピックス、ニュース及びメールマガジンに掲載される情報等及びこれに関連する一切の知的財産権を全世界において独占的に保有するものとします。但し、お客様が投稿した投稿コンテンツについては、お客様又は適法な利用権者に帰属するものとします。
        </li>
        <li>
          お客様は、当社が運営するサービス「croccha」「croccha
          shop」において自らが利用及び処分する権限を有し、かつ適法並びに有効に投稿及び登録する権限を有する投稿コンテンツのみを投稿するものとします。
        </li>
        <li>
          お客様は、当社に対し、当社が運営するサービス「croccha」「croccha
          shop」及び当社が運営するサービスの宣伝広告並びに当社及び当社の関連会社の事業での利用等を含めたあらゆる目的との関連で、第1項に定める投稿コンテンツ等の知的財産権の全部又は一部を、全世界において非限定的、譲渡可能、複製可能、改変可能、公衆送信（自動公衆送信の場合の送信可能化を含みます。）可能、頒布可能、サブライセンス可能で、無償且つ非独占的に、利用する権利を許諾するものとします。
        </li>
        <li>
          お客様は、本条第3項の範囲において当社が利用する知的財産権について、著作者人格権や肖像権を行使しないこととします。
        </li>
        <li>
          本条の規定に違反して、お客様が第三者との間で何らかの問題が生じた場合、お客様は自己の責任と費用において当該問題を解決し、当社に対して何らの損害、損失又は費用を生じさせないものとします。また、万が一、当社に何らかの損害、損失又は費用が生じた場合には、お客様は、当該損害、損失又は費用を全て賠償又は支出するものとします。
        </li>
      </ol>

      <h4>第9条（利用者情報の取扱い）</h4>
      <ol>
        <li>
          本アカウントおよび本アカウントの利用により利用者から取得した一切の情報（利用者の氏名、ID、アイコン用画像、コメント、アイテム情報、画像等を含みますが、これらに限りません。以下「利用者情報」といいます。）は当社に帰属するものとします。ただし、お客様がcroccha公認アカウントを利用し利用者から直接入手したまたはお客様がcroccha公認アカウント上で指定したcroccha公認アカウント外のリンク先において収集した利用者の情報についてはこの限りではありません。
        </li>
        <li>
          お客様は、利用者情報を本アカウントの運営に必要な範囲内でのみ収集・使用できるものとし、当社からの電子メールを含む書面による事前の許諾なく第三者に開示、提供、漏洩または本アカウントの運営目的以外での再利用をしてはならないものとします。
        </li>
        <li>
          お客様は、croccha公認アカウントの利用にかかる契約が解約または終了した場合もしくはcrocca公認アカウントの提供が終了した場合、直ちに利用者情報を廃棄するものとします。
        </li>
      </ol>

      <h4>第10条（通知義務）</h4>
      <p>
        お客様は、お客様の商号、名称、croccha公認アカウントに登録したお客様の担当者、e-mailアドレス、住所その他の連絡先を変更した場合、直ちに、当社所定の方法により、かかる変更を通知するものとします。かかる通知を受けた場合、当社は、お客様に対し、かかる変更を証明する資料の提出を求めることができ、お客様はこれに応じるものとします。
      </p>

      <h4>第11条（お客様の責任）</h4>
      <ol>
        <li>
          お客様がcroccha公認アカウントを利用したことに起因して、当社に対し、第三者からクレーム、請求または訴訟等が提起された場合、お客様は自らの責任と費用負担によりこれに対応するものとし、当社に迷惑を及ぼしてはなりません。
        </li>
        <li>
          お客様がcroccha公認アカウントを利用したことに起因して、当社が何らかの損害（弁護士費用の負担を含みます。）を被った場合、お客様は、当社に対し、直ちにこの損害を賠償するものとします。
        </li>
      </ol>

      <h4>第12条（croccha公認アカウントの退会）</h4>
      <ol>
        <li>
          お客様はいつでも、croccha公認アカウントを退会することができます。
        </li>
        <li>
          croccha公認アカウントを退会した場合、一般アカウントとして利用は継続されます。
        </li>
        <li>
          第5条弟8項または前項の規定にかかわらず、お客様にcroccha公認アカウントの利用料金の未払いがある場合に限り、お客様が本アカウントの退会手続きを行った場合であっても、当社が利用料金の未払いがなくなったことを確認できた日まで本条第二項に定める権限は存続するものとします。
        </li>
      </ol>

      <h4>第13条（お客様情報の取扱い）</h4>
      <ol>
        <li>
          当社は、お客様が当社に提供したお客様の個人情報を、croccha公認アカウントの事務処理のほか
          <a href='https://try.croccha.com/privacypolicy' target='_blank'>
            crocchaプライバシーポリシー
          </a>
          に記載した内容に準拠した範囲において使用します。
        </li>
        <li>
          当社は、法令およびcrocchaプライバシーポリシーで定める場合ならびに別途お客様から個別に同意を得た場合を除き、お客様の同意なく、お客様の個人情報を第三者に提供しません。
        </li>
        <li>
          お客様は、当社に対して、当社がお客様から収集した個人情報について、開示、訂正、追加および削除を請求することができます。ただし、当該開示、訂正、追加および削除は当社が別途定める手続きによるものとし、別途手数料が必要となる場合があります。開示、訂正、追加、削除および苦情に関するお問い合わせは
          <a href='mailto:info@croccha.jp'>info&#64;croccha.jp</a>
          へメールにてご連絡ください。
        </li>
      </ol>

      <h4>第14条（委託・業務提携）</h4>
      <ol>
        <li>
          当社は、croccha公認アカウントのサービス提供の一部を、その他の第三者に委託することができます。
        </li>
        <li>
          当社は、業務提携先その他第三者のウェブサイト、アプリ等にcroccha公認アカウントの機能を提供するため、お客様のcroccha公認アカウントに関する情報（ただし、個人情報ではない情報とします。）を業務提携先その他第三者に提供することができるものとします。これにより、お客様のcroccha公認アカウントへのリンク等が、提携先その他第三者サイトに掲載されることがあります。また、当社は、お客様のアカウントページに、業務提携先におけるお客様の情報が記載されたウェブサイトのURLの掲載、当該ウェブサイトへのリンクの設置等をすることができるものとします。
        </li>
      </ol>

      <h4>第15条（サービスの中断・変更・終了）</h4>
      <ol>
        <li>
          当社は以下の場合、croccha公認アカウントのサービス提供を一時中断することがあります。以下の事情に基づいて、当社がcroccha公認アカウントを一時中断した場合、当社は、お客様に対し、何ら責任を負わないものとします。
          <br />
          <ul>
            <li>
              (1)croccha公認アカウントの提供に必要な設備の保守点検等を定期的または緊急に行う場合
            </li>
            <li>
              (2)croccha公認アカウントの提供に用いる設備に障害・故障等が生じた場合
            </li>
            <li>
              (3)電気通信事業者の提供する役務に起因して、電気通信サービスの利用が不能となった場合
            </li>
            <li>
              (4)停電、火災、地震、労働争議その他不可抗力によりcroccha公認アカウントの提供が困難な場合
            </li>
            <li>
              (5)その他、croccha公認アカウントの運用上または技術上の相当な理由がある場合
            </li>
          </ul>
        </li>
        <li>
          当社は、お客様に公表または通知することにより、croccha公認アカウントの全部または一部を変更しまたは終了することができるものとします。当社がcroccha公認アカウントの全部または一部の変更または終了した場合であっても、当社は、お客様に対し、何ら責任を負わないものとします。
        </li>
      </ol>

      <h4>第16条（非保証）</h4>
      <p>
        当社は、croccha公認アカウントに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害等を含みますが、これらに限りません。）がないことを明示的にも黙示的にも保証しません。
      </p>

      <h4>第17条（損害賠償）</h4>
      <ol>
        <li>
          お客様が、本規約に違反し、よって当社に損害を与えた場合には、その一切の損害（合理的な弁護士費用を含みますが、これに限りません。）を直ちに賠償する責任を負うものとします。
        </li>
        <li>
          お客様は、croccha公認アカウントに関連してcroccha公認アカウントの利用者を含む第三者から当該第三者の権利を侵害した等のクレーム、主張、要求、請求、異議等（以下「クレーム等」といいます。）を受けた場合、自らの費用と責任で当該クレーム等を処理解決するものとし、当該クレーム等に関連して当社が損害を被った場合には、その全ての損害を直ちに賠償する責任を負うものとします。なお、当社が当該クレーム等を処理解決した場合には、その処理解決に要した全ての費用は、お客様の負担とするものとします。
        </li>
        <li>
          お客様がcroccha公認アカウントを利用して、外部のサービスへ利用者を誘導する場合、技術上の原因その他の原因により、当該外部サービスを利用者が利用できない場合があります。また、かかる誘導によって、お客様は利用者からのクレーム、Apple
          inc.、Google
          LLC等のプラットフォーマーによる不利益な対応、その他の不利益（以下総称して「本件不利益」といいます。）を被る可能性があります。お客様はこれらの可能性を認識した上で、自己の責任で外部サービスへの誘導を行うものであり、当該外部サービスを利用できない事態が生じることおよび本件不利益について、当社は一切その責任を負わないものとします。
        </li>
        <li>
          当社は、お客様がcroccha公認アカウントを利用したことに起因してお客様に生じたあらゆる損害について一切の責任を負いません。ただし、この損害が当社の故意または重大な過失によって発生した場合はこの限りでなく、この場合、当社はお客様に生じた通常かつ直接の損害について、この損害が発生した月にお客様が現に支払ったcroccha公認アカウントの利用料金額を上限として、これを賠償する責任を負います。
        </li>
      </ol>

      <h4>第18条（アカウントの利用制限）</h4>
      <p>
        お客様が、本規約第1条に基づきcroccha公認アカウントの利用を開始した後でも、当社は、お客様が以下の事項に該当すると判断した場合、croccha公認アカウントの利用を認めない、または利用を停止する等の制限を行う場合があります。なお、以下の事項は例示であり、当社に具体的な判断基準やアカウントの利用制限についてお問い合わせを頂いても回答義務を負わないものとします。
      </p>
      <ul>
        <li>
          (1)犯罪に使用されるおそれが高い商品の販売、またはサービスの提供を行っている法人・団体・個人
        </li>
        <li>
          (2)不法行為または犯罪行為を構成しまたは助長するおそれのある法人・団体・個人
        </li>
        <li>
          (3)他人の個人情報、登録情報、利用履歴情報などの違法または不正な売買・仲介・斡旋等を行っている法人・団体・個人
        </li>
        <li>
          (4)法令または公序良俗に反する行為を行っているもしくは行うおそれの高い法人・団体・個人
        </li>
        <li>
          (5)本規約第19条に定める禁止行為を行っていると当社が判断する法人・団体・個人
        </li>
        <li>
          (6)その他当社がcroccha公認アカウントのアカウント利用に不適当であると判断する法人・団体・個人
          <br />
          （crocchaユーザーに不利益を被らせる可能性のある法人・団体・個人、当社の信用もしくは評判に悪影響を与える可能性のある法人・団体・個人、当社をクレームや紛争等に巻き込む可能性のある法人・団体・個人などが含まれますが、これらに限りません。）
        </li>
      </ul>

      <h4>第19条（禁止行為）</h4>
      <p>
        お客様は、croccha公認アカウントの利用に際して、以下に記載することを行なってはなりません。
      </p>
      <ul>
        <li>
          (1)法令、裁判所の判決、決定もしくは命令、または法令上拘束力のある行政措置に違反する行為
        </li>
        <li>(2)違法または違法行為を助長するような行為</li>
        <li>
          (3)当社または第三者の著作権、商標権、特許権等の知的財産権、名誉権、プライバシー権、その他法令上または契約上の権利を侵害する行為
        </li>
        <li>(4)公序良俗に反するおそれのある行為</li>
        <li>(5)反社会的勢力に対する利益供与その他の協力行為</li>
        <li>
          (6)当社の事前の承諾なく、croccha公認アカウントを第三者のための広告媒体として使用する行為（第三者の商品、サービスについてcroccha公認アカウントを利用して宣伝することを含みますが、これに限りません。）
        </li>
        <li>
          (7)croccha公認アカウントを利用してみなし属性を利用した広告、メッセージ等（以下、「広告等」といいます。）を配信する場合、広告等に接触した利用者の属性を識別する行為（広告等の配信時に属性毎に個別の遷移先を指定することおよび遷移先を指定するURL中に遷移経路を追跡可能にする特定の情報の付加等をすることが含まれますが、これに限りません。）
        </li>
        <li>
          (8)本アカウントを第三者に譲渡または貸与する行為、第三者と共用する行為
        </li>
        <li>
          (9)当社または第三者になりすます行為、意図的に虚偽の情報を流布させる行為またはお申し込みされた業種の運営・維持とはなんら関係のない内容を表示もしくは配信する行為
        </li>
        <li>
          (10)第三者の個人情報、登録情報、利用履歴情報などを、不正に収集、開示または提供する行為
        </li>
        <li>
          (11)過度に暴力的な表現、露骨な性的表現、人種、国籍、信条、性別、社会的身分、門地等による差別につながる表現、自殺、自傷行為、薬物乱用を誘引または助長する表現、その他反社会的な内容を含み他人に不快感を与える表現を、投稿または送信する行為
        </li>
        <li>
          (12)性行為やわいせつな行為を目的とする行為、面識のない異性との出会いや交際を目的とする行為、他のお客様に対する嫌がらせや誹謗中傷を目的とする行為、その他croccha公認アカウントが予定している利用目的と異なる目的でcroccha公認アカウントを利用する行為
        </li>
        <li>(13)利用者または第三者が、不快または迷惑と思う内容の配信</li>
        <li>
          (14)croccha公認アカウントのサーバやネットワークシステムに支障を与える行為
        </li>
        <li>
          (15)当社によるcroccha公認アカウントの運営または他のお客様によるcroccha公認アカウントの利用を妨害し、これらに支障を与える行為
        </li>
        <li>(16)croccha公認アカウントの不具合を意図的に利用する行為</li>
        <li>(17)当社に対し不当な問い合わせまたは要求をする行為</li>
        <li>(18)croccha利用規約又は本規約に違反する行為</li>
        <li>
          (19)上記第1項から18項のいずれかに該当する行為を援助または助長する行為
        </li>
        <li>(20)その他、当社が不適当と判断した行為</li>
      </ul>
      <h4>第20条（利用停止・解除）</h4>
      <ol>
        <li>
          当社は、お客様が以下のいずれかに該当し、または該当するおそれがあると当社が判断した場合、お客様によるcroccha公認アカウントの利用を予告なく一時停止しまたは何らの催告を要することなくお客様との間の本規約に基づく契約関係（以下「本契約」といいます。）を解除して、croccha公認アカウントの提供を中止することができます。かかる利用停止または解除に起因してお客様に何らかの損害が生じた場合であっても、当社は、お客様に対し、何ら責任を負わないものとします。
          <br />
          <ul>
            <li>
              (1)croccha公認アカウントの利用開始後に当社が第2条第4項に定める申し込み拒否事由があることを知った場合（認証済アカウントか否かを問いません。）
            </li>
            <li>(2)本規約第19条の禁止行為に抵触する等、本規約に違反した場合</li>
            <li>(3)不正の目的をもってcroccha公認アカウントを利用した場合</li>
            <li>
              (4)破産もしくは民事再生の手続きの申し立てを受けるまたはお客様自身がそれらの申し立てを行うなど当社がお客様に信用不安が発生したと判断した場合
            </li>
            <li>
              (5)当社の責に帰すべき理由によらず、1か月間お客様と連絡が取れない場合
            </li>
            <li>(6)本アカウントへ1年以上アクセスしていない場合</li>
            <li>(7)その他、当社が不適切と判断する行為をお客様が行った場合</li>
          </ul>
        </li>
        <li>
          当社は、Apple inc.、Google
          LLCその他当社が利用するアプリマーケットを運営、提供する第三者からcroccha公認アカウントの一部または全部の提供を停止するよう求められた場合、お客様によるcroccha公認アカウントの利用を予告なく一時停止しまたは何らの催告を要することなく本契約を解除して、croccha公認アカウントの提供を中止することができます。
        </li>
        <li>
          前二項にかかる利用停止または解除に起因してお客様に何らかの損害が生じた場合であっても、当社は、お客様に対し何ら責任を負わないものとします。
        </li>
      </ol>

      <h4>第21条（機密保持）</h4>
      <p>
        お客様は、当社の機密情報（当社の顧客、製品、サービス、事業、技術、ノウハウ、アイデア、コンセプト等に関する一切の情報とします。）を秘密として保持するものとし、法令により開示が義務付けられる場合を除き、当社の書面による承諾なく当社の機密情報を第三者に開示または漏洩してはならないものとします。
      </p>

      <h4>第22条（反社会的勢力の排除）</h4>
      <ol>
        <li>
          お客様は、自己またはその代表者、役員、実質的に経営権を有する者、従業員、代理人または媒介者（以下「関係者」といいます。）が、現在、暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋、社会運動標ぼうゴロ、政治活動標ぼうゴロ、特殊知能暴力集団またはこれらの者と密接な関わりを有する者もしくはこれらに準じる者（以下「反社会的勢力」といいます。）のいずれにも該当しないことを表明し、かつ、将来にわたっても該当しないことを確約するものとします。
        </li>
        <li>
          お客様は、自らまたはその関係者が、直接的または間接的に、以下の行為を行わないことを確約するものとします。
          <br />
          <ul>
            <li>(1)暴力的な要求行為</li>
            <li>(2)法的な責任を超えた不当な要求行為</li>
            <li>
              (3)取引に関して、脅迫的な言動（自己またはその関係者が反社会的勢力である旨を伝えることを含みますが、これに限りません。）をし、または暴力を用いる行為
            </li>
            <li>
              (4)風説を流布し、偽計を用いまたは威力を用いて当社の信用を毀損し、または当社の業務を妨害する行為
            </li>
            <li>(5)その他前各号に準じる行為</li>
          </ul>
        </li>
        <li>
          お客様が前二項に定める表明事項または確約事項のいずれかに違反することが判明した場合、当社は、何らの催告を要することなく本契約を解除して、croccha公認アカウントの提供を中止することができます。かかる解除に起因してお客様に何らかの損害が生じた場合であっても、当社は、お客様に対し、何ら責任を負わないものとします。
        </li>
      </ol>

      <h4>第23条（地位の譲渡および承継）</h4>
      <ol>
        <li>
          お客様は、当社の承諾がない限り、本契約に関する権利義務または契約上の地位を第三者に譲渡し、担保の目的に供しあるいは承継させてはならないものとします。
        </li>
        <li>
          当社がcroccha公認アカウントの全部または一部を当社のグループ会社その他の第三者に譲渡する場合、当社は、お客様に公表または通知することにより、本契約上の当社の地位を当該第三者に譲渡することができ、お客様は予めこれに同意するものとします。
        </li>
      </ol>

      <h4>第24条（分離可能性）</h4>
      <p>
        本規約の一部が法令等により無効と判断された場合であっても、無効部分以外の規定は引き続き有効に存続します。また、無効部分は、有効とするために必要最小限の範囲で修正され、意図した法律的効果と経済的効果が最大限確保されるよう解釈されるものとします。
      </p>

      <h4>第25条 （準拠法）</h4>
      <p>本規約、および個別契約は、日本法を準拠法とします。</p>

      <h4>第26条 （専属的合意管轄）</h4>
      <p>
        本規約、および個別契約または本サービスに関する紛争について、訴訟の必要が生じた場合は、大阪地方裁判所又は大阪簡易裁判所を第一審の専属的合意管轄裁判所とします。
      </p>

      <h4>第27条 （協議）</h4>
      <p>
        本規約、および個別契約に定めのない事項については、当社とお客様が誠意をもって協議のうえ、信義に則して解決するのもとします。
      </p>

      <p>以上</p>
      <p>(制定) 2019年8月8日</p>

      <h2 id='guideline'>「croccha」公認アカウントガイドライン</h2>

      <p>
        はじめに
        <br />
        １）croccha公認アカウントガイドライン
      </p>

      <p>
        croccha公認アカウントガイドライン（以下「本ガイドライン」といいます）は、tryangle株式会社（以下「当社」といいます）がお客様に対して提供するcroccha公認アカウント（以下「本サービス」といいます）にあたり、法人・団体・個人を問わずどなたでも利用できる「一般アカウント」と、当社所定の審査を通過したお客様のみが利用できる「croccha公認クリエイターアカウント」および「croccha公認ショップアカウント」の違い、アカウントに関する審査、アカウント開設・運用時の注意事項を解説し、本サービスをお客様に円滑にご利用いただくことを目的として定めるものです。
      </p>

      <p>
        本ガイドラインは、croccha公認クリエイターアカウント利用規約（以下「croccha利用規約」といいます）とあわせ、当社の基準に基づき日本を所属国として割り当てたアカウントにのみ適用されます。
      </p>

      <p>
        本ガイドラインに定めがない場合、原則として利用規約の定めが適用されるものとし、本ガイドラインの定めが利用規約の定めと矛盾もしくは抵触する場合、その限りにおいては、本ガイドラインが優先して適用されるものとします。
      </p>

      <a href='#terms'>&#9632;croccha利用規約</a>
      <br />
      <a href='#account'>&#9632;croccha公認アカウント利用規約</a>

      <p>
        ２）サービスポリシー
        <br />
        まず、croccha公認アカウントには、「croccha公認クリエイターアカウント」と、「croccha公認ショップアカウント」の２つのサービスがあります。以下、この２つのサービスを併せて「croccha公認アカウント」といいます。
      </p>

      <p>
        まず、「croccha公認クリエイターアカウント」は、アカウント主であるお客様が全国のcrocchaユーザーと「公認ショップ」様とのエンゲージメントを高め、コミュニティを活性化させるために利用可能なアカウントサービスです。
      </p>

      <p>
        次に「croccha公認ショップアカウント」は、アカウント主であるお客様が全国のcrocchaユーザーとのエンゲージメントを高めるために利用可能なアカウントサービスです。
      </p>

      <p>
        ユーザーはcroccha公認アカウントをフォローすることで、投稿を参考にしたり、アイテム情報を参考に材料を購買したり、コメント欄を通じてメッセージを交わしたり、さまざまな情報を受け取ったりするなど、日々のハンドメイドライフをより充実したものとするために利用することができます。
      </p>

      <p>
        一方で、「croccha」という媒体は、子どもから大人まで幅広い年齢層のユーザーが日々利用する、ハンドメイドに関するコミュニケーションプラットフォームでもあります。
      </p>

      <p>
        そのため、当社はcroccha公認アカウントから配信されるコンテンツについて「情報の受け手（ユーザー）がどう思うか」「ユーザーが必要とする情報を適切な形で提供しているか」「ユーザーが不快に感じることはないか」「すべてのユーザーが安心・安全にcrocchaを利用できているか」という点を大切にしております。
      </p>

      <p>
        当社では、crocchaを通じてお客様とユーザーによりよい信頼関係を築いていただくことで、croccha上のユーザー体験をより充実したものとするべく、本ガイドラインを定めております。
      </p>

      <h3>アカウント開設時のルール</h3>
      <h4>１）アカウントの種別と審査</h4>
      <ol>
        <li>
          アカウントの種別
          <br />
          <p>
            本サービスは、法人・団体・個人を問わずご利用いただける「一般アカウント」と、当社所定の審査を通過したお客様のみにご利用いただける「公認アカウント」のいずれかの種別においてお客様に提供されます。
            <br />
            また「公認アカウント」の内容には個人のクリエイターさんが利用できる「公認クリエイターアカウント」と法人の小売店様等が利用できる「公認ショップアカウント」がございます。
          </p>
          <p>
            また、当社は、当社が定める一定の基準を満たした公認アカウントについて、「プレミアムアカウント」とすることがありますが、当該アカウントをプレミアムアカウントとする基準については公開する義務を負わないものします。
          </p>
        </li>
        <li>
          公認アカウントの開設審査
          <br />
          公認アカウントをお申し込みいただいた際は、当社所定の審査を実施します。
          <br />
          croccha公認アカウント利用規約第2条「利用申し込み・認証・認証拒絶または取消」第4項各号に記載の拒絶
          <br />
          または取消理由に加え、お客様の業種・業態や事業内容等によっては、当社の裁量により、公認アカウントの開設をお断りさせていただく場合があります。
        </li>
        <li>
          審査基準
          <br />
          公認アカウントの開設にあたっては、以下の基準に基づき審査を実施します。
          <ol>
            <li>crocchaユーザーの不利益につながる可能性がないか</li>
            <li>法令における規制の有無と規制内容に抵触するものでないか</li>
            <li>利用規約第19条「禁止行為」各号に該当するおそれがないか</li>
            <li>当社が独自に定める審査基準を満たすか否か</li>
            <li>
              当社の事業へ悪影響を及ぼす、あるいは当社の信用を損なうものでないか
            </li>
          </ol>
          なお、当社はお客様に対し、審査結果およびその理由について説明する義務を負わないものとします。
        </li>
        <li>
          お客様の責任
          <br />
          審査の結果、当社が認証済アカウントの開設を承諾した場合であっても、当社の承諾は本サービス利用にあたってのお客様の法的・社会的責任を軽減するものではありません。
          <br />
          本サービスをお申し込みになる時点で、本サービスの利用によって生じるお客様の法的・社会的責任をお客様ご自身が負うことを承諾されたものとみなします。また、当社はお客様が本サービスを利用することにより第三者に対して損害を与えた場合においても、当社に、故意または重過失が認められる場合を除き、その一切の責任を負わないものとします。
        </li>
      </ol>

      <h4>２）ご利用いただけないお客様</h4>
      <p>
        お客様が以下の各号の一に該当すると当社が判断した場合は、アカウントの種別にかかわらず、本サービスをご利用いただけません。あらかじめご了承ください。
      </p>
      <ul>
        <li>
          ・犯罪に使用されるおそれのある商品またはサービスの提供を行っている法人・団体・個人
        </li>
        <li>
          ・不法行為または犯罪行為を構成しまたは助長するおそれのある法人・団体・個人
        </li>
        <li>
          ・他人の個人情報、登録情報、利用履歴情報などの違法または不正な売買・仲介・斡旋等を行っている法人・団体・個人
        </li>
        <li>
          ・法令または公序良俗に反する行為を行っている若しくは行うおそれのある法人・団体・個人
        </li>
        <li>
          ・croccha公認アカウント利用規約第19条に定める禁止行為を行っていると当社が判断する法人・団体・個人
        </li>
        <li>
          ・その他当社が本サービスの利用が不適当であると判断する法人・団体・個人（crocchaユーザーに不利益を被らせる可能性のある法人・団体・個人、当社の信用若しくは評判に悪影響を与える可能性のある法人・団体・個人、当社をクレームや紛争等に巻き込む可能性のある法人・団体・個人などが含まれますが、これらに限られません）
        </li>
      </ul>

      <h4>３）ご利用いただけない業種・業態、商品・サービス</h4>
      <p>
        当社ポリシーにより、全部もしくは一部に関わらず、croccha公認アカウント利用規約、croccha利用規約に違反する場合、下記に該当すると当社が判断した場合、アカウントの提供を認めない、又はアカウントの提供を停止し、本サービスにかかる契約を解除する等の措置をとらせていただくことがあります。あらかじめご了承ください。
      </p>

      <p>
        なお、以下はあくまで一例であり、記載のないケースにおいても、本サービスの利用をお断りすることがあります。あらかじめご了承ください。
      </p>
      <ol>
        <li>
          ハンドメイド、フラワー、ガーデニング、ＤＩＹ、等のものづくり以外に関連しない業種、業態、商品・サービス
        </li>
        <li>
          ハンドメイド、フラワー、ガーデニング、ＤＩＹ、等のものづくりに関連する業種、業態、商品、サービスであっても、以下のケースは利用ができません。
        </li>
        <p>ネット関連ビジネス</p>
        <p>
          【商品・サービス】
          <br />
          情報商材
          <br />
          【掲載できないケース】
          <br />
          「儲かる/儲ける」等の内容を謳って集客し、メールマガジン登録、動画・DVD販売やセミナー開催等へ誘導するもの
        </p>
        <p>
          【商品・サービス】
          <br />
          能力開発商材
          <br />
          【掲載できないケース】
          <br />
          「◯◯するだけ」等、消費者が簡単に始められるような内容を謳って、メールマガジン登録、動画・DVD販売、セミナー開催等へ誘導するもの
          <br />
          ※ハンドメイドの資格講座の宣伝には弊社審査による承認が必要です。
          <br />
          ※ハンドメイドワークショップに関する情報は内容が不適切でなければ制限はございません。
        </p>

        <p> 個人情報</p>
        <p>
          【商品・サービス】
          <br />
          個人情報販売
          <br />
          【掲載できないケース】
          <br />
          氏名、性別、生年月日等の個人を識別する情報の販売
        </p>
        <p> 模倣品・海賊版</p>
        <p>
          【商品・サービス】
          <br />
          模倣品・海賊版
          <br />
          【掲載できないケース】
          <br />
          ・芸能人・キャラクター等の模倣品・海賊版・非公式グッズ販売
          <br />
        </p>
      </ol>

      <h3>アカウント運用時のルール</h3>
      <h4>１）アカウント名称の設定</h4>
      <p>
        公認アカウントのアカウント名称は、以下の定めに従い設定をお願いします。
        <br />
        抵触する名称については当社より修正をお願いする場合があります。
      </p>
      <ol>
        <li>
          法人・団体・個人または商品・サービスのいずれかの正式名称が必ず含まれること
        </li>
        <li>
          実在しない法人・団体・個人または商品・サービスが実在するかのように誤認されないこと
        </li>
        <li>
          事実とは異なるまたは誤認を招くような内容の文字列が使用されていないこと
        </li>
        <li>当社または関連会社の商品・サービスと誤認されないこと</li>
      </ol>
      <p>
        公認アカウントのアカウント表示名の変更については当社の審査が必要です。
        <br />
        企業名・サービス名変更等の事業の場合、変更を希望する場合においては、名称変更に伴う再審査を行いますので、ご連絡をください。
      </p>

      <h4>２）配信コンテンツに関する禁止事項</h4>
      <p>
        アカウントの種別を問わず、お客様の配信されたコンテンツ（投稿、アイテムタグ、タイムライン、自動応答等全て含む）またはアカウント設定内容について、croccha公認アカウント利用規約第19条「禁止行為」に該当する以下のような行為を行わないようお願いいたします。
      </p>
      <ul>
        <li>
          •
          法令、裁判所の判決、決定若しくは命令、または法令上拘束力のある行政措置に違反する行為
        </li>
        <li>• 違法または違法行為を助長するような行為</li>
        <li>
          •
          当社または第三者の著作権、商標権、特許権等の知的財産権、名誉権、プライバシー権、その他法令上または契約上の権利を侵害する行為
        </li>
        <li>• 公序良俗に反するおそれのある行為</li>
        <li>• 反社会的勢力に対する利益供与その他の協力行為</li>
        <li>
          • 本サービスをお客様以外の第三者のための広告媒体として使用する行為
        </li>
        <li>
          •
          当社または第三者になりすます行為、意図的に虚偽の情報を流布させる行為またはお申込された業種の運営・維持とはなんら関係のない内容を表示若しくは配信する行為
        </li>
        <li>
          •
          第三者の個人情報、登録情報、利用履歴情報などを、不正に収集、開示または提供する行為
        </li>
        <li>
          •
          過度に暴力的な表現、露骨な性的表現、人種、国籍、信条、性別、社会的身分、門地等による差別につながる表現、自殺、自傷行為、薬物乱用を誘引または助長する表現、その他反社会的な内容を含み他人に不快感を与える表現を、投稿または送信する行為
        </li>
        <li>
          •
          性行為やわいせつな行為を目的とする行為、面識のない第三者との出会いや交際を目的とする行為、他のお客様に対する嫌がらせや誹謗中傷を目的とする行為、その他本サービスが予定している利用目的と異なる目的で本サービスを利用する行為
        </li>
        <li>• 利用者または第三者が、不快または迷惑と思う内容の配信</li>
        <li>• 本サービスのサーバやネットワークシステムに支障を与える行為</li>
        <li>
          •
          当社による本サービスの運営または他のお客様による本サービスの利用を妨害し、これらに支障を与える行為
        </li>
        <li>• 本サービスの不具合を意図的に利用する行為</li>
        <li>• 当社に対し不当な問い合わせまたは要求をする行為</li>
        <li>• croccha利用規約に抵触する行為</li>
        <li>• 上記のいずれかに該当する行為を援助または助長する行為</li>
        <li>• その他､当社が不適当と認める行為</li>
      </ul>

      <h4>３）罰則</h4>
      <p>
        アカウントの種別を問わず、お客様が配信されたコンテンツまたはアカウントの設定内容に当社が不適切と判断する表現があった場合、および上記２）「配信コンテンツに関する禁止事項」、下記４）「運用上の注意事項」に抵触する行為があった場合、当社はお客様に対し、以下のような措置をとらせていただく場合がございます。この場合、当社は、当社が行った措置に基づきお客様に生じた損害について一切の責任を負いません。
      </p>
      <ul>
        <li>• 当該コンテンツの削除</li>
        <li>• 本サービスの提供停止</li>
        <li>• 本サービスにかかる契約の解除</li>
      </ul>
      <p>
        なお、いずれの場合においても、当社はその理由について回答する義務を負わないものとします。
      </p>

      <h4>４）運用上の注意事項</h4>
      <p>
        アカウントの運用にあたっては、各種法令、業界が定める自主基準やルールをご遵守ください。また、ユーザー保護の観点から、アカウントを通じて発信する内容については、以下の注意事項をご遵守ください。
        <br />
        内容に関する事前審査は原則ございませんが、当社にて配信時のモニタリングを行い、抵触した項目によっては、投稿内容の削除、アカウントの停止等の対応を行う場合もございます。ご理解の上、配信をお願いいたします。
      </p>
      <ul>
        <li>
          ・ＰＣ，スマートフォンで操作・閲覧できないページへのリンク
          <br />
          ＰＣ、スマートフォン（iOS、Android）の標準ブラウザで操作・閲覧できないページヘのリンクはお控えください。リンク先のページがスマートフォンで正常に動作することを推奨いたします。
        </li>
        <li>
          ・ユーザーが誤認や誤操作を行う可能性のある表現
          <br />
          リンク領域が不明瞭、実際に機能しないボタンやメニュー等、誤認や誤操作等、ユーザー体験が著しく損なわれる内容はお控えください。
        </li>
        <li>
          ・アプリのダウンロードに関する訴求
          <br />
          アプリの訴求につきましては、App Store、Google
          Play等の規約、当社の利用規約、croccha利用規約ならびに本ガイドラインの免責事項をご確認の上、慎重にご検討ください。
        </li>
        <li>
          ・アカウント名称の変更
          <br />
          公認アカウントのアカウント表示名の変更については審査が必要です。
          但し、企業名・サービス名変更等の事業の場合、変更を希望する場合においては、名称変更に伴う再審査を行います。
        </li>
        <li>
          ・アイコン画像の変更
          <br />
          アイコン画像にはユーザーからみて不自然でないことが求められるため、『アカウント名称に関連した画像』を推奨いたします。
          <br />
          またフォロワー数が一定数以上のお客様についてはお客様ご自身で変更することはできませんので、ご希望の場合は別途お問い合わせください。
          <br />
          なお、頻繁なご変更や急なご変更により、フォローしているユーザーが違和感をおぼえないよう、ご配慮ください。
        </li>
      </ul>

      <h4>5) 運用上の注意事項(商用利用の場合)</h4>
      <p>
        アカウントの商用利用にあたっては、前ページの注意事項に加え、以下の内容についても、あわせてご遵守のうえ、アカウント運用をお願いいたします。
      </p>
      <ul>
        <li>
          ・主体者の明示
          <br />
          お客様が権利を保有しない素材を利用する場合は、必ず権利者名を明記し、当該権利者との関係性を明確にしてください。
        </li>
        <li>
          ・他社商品、サービスの訴求
          <br />
          特定の商材やサービスを取り上げた訴求は、以下の場合のみ認められます。
          <br />
          1. お客様が自社製品・自社サービスの商材を訴求する場合
        </li>
        <li>
          ・リンク先の制限
          <br />
          テキストやクリエイティブと直接関係ないページへのリンクはお控えください。またお客様が実質的に管理されていないページへリンクすることはできません。投稿写真と本文、レシピ、リンク先ページが関係し、ユーザーからみて不自然でない内容であることが求められます。
        </li>
        <li>
          ・投稿内容の訂正
          <br />
          投稿内容の修正時には作品の作り方、材料等、重大な変更があった場合は必ず訂正があることをコメント欄に明記し、ご投稿ください。
        </li>
      </ul>

      <h4>６）免責事項</h4>
      <ul>
        <li>
          ・タイムラインの投稿およびコメント欄に、当社が不適切と判断する投稿があった場合、事前予告なく削除させていただく場合がございます。
        </li>
        <li>
          ・アカウントをフォローしているユーザーの情報（アカウント名称、IDを含みますが、これに限りません）はユーザー自身が公開されている情報以外、当社より一切開示できません（一部機能を除く）。またユーザー自身が公開されている場合であってもリスト化するなどの対応は一切できません。
        </li>
        <li>
          ・crocchaはインターネット及びスマートフォン（iOS、Android）を対象としたサービスであるため、PC、iOSおよびAndroid以外のスマートフォンOSでは最低限の機能は有しておりますが、各種機能の動作表示の保証はいたしかねます。
        </li>
        <li>
          ・本サービスの機能および本ガイドラインの内容は予告なく変更する場合がございます。また、当社は、必要に応じ、お客様に公表または通知することにより、本ガイドラインを変更できるものとします。お客様は、変更後引き続き本サービスを利用した場合、又は当社の定める期間内に登録取消の手続をとらなかった場合、本ガイドラインの変更に同意したものとみなされます。
        </li>
        <li>
          ・お客様が本サービスを利用して、外部のサービスへユーザーを誘導する場合、技術上の原因、その他の原因により、当該外部サービスを利用者が利用できない場合があります。また、かかる誘導によって、お客様はユーザーからのクレーム、プラットフォーマーによる不利益な対応、その他の不利益（以下、総称して「本件不利益」といいます）を被る可能性があります。お客様はこれらの可能性を認識した上で、自己の責任で外部サービスへの誘導を行うものとし、当該外部サービスを利用できない事態が生じることおよび本件不利益について、当社は一切その責任を負わないものとします。
        </li>
      </ul>
      <p>以上</p>

      <h2 id='kuroko'>croccha レシピ自動生成ツール　クロコちゃん 利用規約</h2>

      <p>
      クロコちゃん（以下、「本サービス」といいます。）のご利用に際しては、以下の利用規約をお読みいただき、ご同意下さいますようお願いします。<br />
      以下の利用条件に記載がない事項については、<a href="#terms" >crocchaのご利用規約</a>が適用されます。なお、以下の利用規約とcrocchaご利用規約の条項が異なる場合には、当該規約の定めが本規約の条項に優先すると明記されていない限り、本規約の条項が優先して効力を有します。
      </p>

      <ol>
        <li>
          本サービスは開発中のものを提供するものであり、その性質上、バグ、誤作動、誤記載等が含まれる可能性があり、当社は、本サービスについて何ら保証するものではありません。また、当社は、本サービスを利用したことにより、本サービスを利用する者（以下、「利用者」といいます。）に生じた損害については、一切の責任を負いません。
        </li>
        <li>
          当社は、当社の判断に基づき、事前予告なしに、本サービスの内容を変更することや、本サービスの提供を中断または中止することがあります。
        </li>
        <li>
          利用者は、本サービスを利用するにあたって、<a href="https://openai.com/policies/terms-of-use" target="_blank" rel="noopener noreferrer">OpenAIの利用規約</a>を遵守するものとします。
        </li>
        <li>
        利用者が本サービスを用いて入力した内容には、crocchaご利用規約が適用されます。利用者は、本サービスに基づき出力される内容には、誤った情報や有害な指示・偏った内容が含まれる可能性があることをあらかじめ了承するものとします。また、当社は、本サービスに基づき出力される内容が当社や第三者の権利を侵害するものでないことを保証するものではありません。著作権の侵害にあたる可能性は否定できず、投稿前に必ず利用者自身で確認するものとします。
        </li>
        <li>
        当社は、当社のサービスの内容を改良・改善し、またはサービスの研究・開発等に利用するために、利用者が本サービスを用いて入力した内容および本サービスに基づき出力される内容を収集します。
        </li>
        <li>
        当社は、利用者の事前の承諾を得ることなく、croccha上での掲載又は利用者に対して、あらかじめ登録されたメールアドレスにメール送信をする等、当社が妥当であると判断する方法で利用者に公表又は通知することにより、任意に本規約の全部又は一部を変更できるものとします。また、変更された本規約は当該公表又は通知と同時に適用されるものとします。
        </li>
        <li>
        本利用条件は日本法を準拠法とします。本規約に関して発生する紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
        </li>
      </ol>
      <p>2023年5月2日制定・施行</p>
    </Section>
  </BaseLayoutTemplate>
);

export default TermsOfUsePage;

const SectionHeader = styled.header`
  max-width: 800px;
  padding: 2rem 1rem;
  margin: 0 auto;
`;

const LinkList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  > li {
    width: calc((100% - 1rem) / 2);
    @media ${breakpoint.sp} {
      width: 100%;
      margin-right: 0;
    }
    text-align: center;
    margin-right: 1rem;
    margin-bottom: 1rem;
    :nth-child(2n) {
      margin-right: 0;
    }
    > a {
      color: ${mainColor};
      padding: 1% 8%;
      border: 1px solid ${mainColor};
      box-shadow: 4px 4px 0 #ff9f91;
      display: block;
      background: #fff;
      font-size: 80%;
      margin: 0;
    }
  }
`;

const Section = styled.section`
  max-width: 800px;
  padding: 2rem 1rem;
  font-size: 14px;
  line-height: 1.6;
  color: #444;
  p {
    margin: 0 0 2%;
  }
  a {
    color: ${mainColor};
  }
  li {
    margin: 0 0 0.4rem;
    display: list-item;
  }
  h2 {
    width: 100%;
    margin: 0 auto 40px;
    font-size: 22px;
    font-weight: normal;
    text-align: center;
    background-size: 1px 1px;
  }
  h3 {
    font-size: 140%;
  }
  h4 {
    margin: 30px 0 8px;
    font-size: 1rem;
  }
  ol {
    display: block;
    list-style: decimal;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 10px;
    margin: 0 0 0 0.5rem;
    > li {
      list-style: decimal;
    }
  }
`;
